import React, {useState} from 'react'
import {Col, Form, Row} from 'react-bootstrap'
import Modal from 'react-modal'
import PortalService from '../../pages/PortalPage/PortalService'
import Notify from '../../services/Notify'

import {ButtonHeader} from '../Button/ButtonHeader'
import Loading from '../Loading/Loading'

function ReasonCancelTransactionModal({ showModal, handleShowModal, readpointId }) {

  const [cause, setCause] = useState(null)
  const [isLoading, setIsLoading] = useState(null)

  const portalService = new PortalService()

  const cancelTransaction = async (event) => {
    event.preventDefault()
    try {
      setIsLoading(true)
      await portalService.cancelOperation(readpointId, cause)
    } catch (error) {
      Notify.error('Erro ao cancelar operação', error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Modal isOpen={showModal} style={styles.modal}>
      <Form onSubmit={cancelTransaction}>
        <Row className="h-100">
          <Col md={12} className="align-self-start">
            <h1 className="h1 text-center">Descreva o motivo do cancelamento</h1>
          </Col>
          <Col md={12} className="align-self-center">
            <textarea className="w-100" rows={7} style={{ fontSize: 20 }} onChange={e => setCause(e.target.value)} required />
          </Col>
          <Col md={12} className="d-flex justify-content-around align-items-center mt-5 align-self-end">
            {isLoading ? <Loading /> :
              <React.Fragment>
                <ButtonHeader text="Continuar" style={styles.buttonSuccess} type="submit" />
                <ButtonHeader text="Cancelar" style={styles.buttonError} onClick={() => handleShowModal(false)} />
              </React.Fragment>
            }
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const styles = {
  modal: {
    content: {
      display: 'flex',
      flexDirection: 'column',
      width: '60%',
      position: 'absolute',
      top: '20%',
      left: '27%',
      right: '27%',
      bottom: '20%',
      borderRadius: 15,
      overflow: 'hidden'
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.329)'
    }
  },
  buttonSuccess: {
    backgroundColor: '#00af91',
    height: '42px',
    width: '160px',
    borderRadius: '4px',
    border: 'none',
    fontWeight: 600,
    fontSize: 12,
    color: 'white',
    textAlign: 'center',
    boxShadow: '0px 8px 16px rgba(52, 175, 249, 0.2)'
  },
  buttonError: {
    backgroundColor: '#ec4646',
    height: '42px',
    width: '160px',
    borderRadius: '4px',
    border: 'none',
    fontSize: 12,
    fontWeight: 600,
    color: 'white',
    textAlign: 'center',
    boxShadow: '0px 8px 16px rgba(52, 175, 249, 0.2)'
  }
}

export default ReasonCancelTransactionModal



// WEBPACK FOOTER //
// ./src/component/Modal/ReasonCancelTransactionModal.js